module.exports = __webpack_public_path__ + "img/facebook-login.413fa18b.svg";